<template>
  <component
    :is="componentTag"
    :class="['PeopleCard', {link: link}]"
    :href="link"
    :target="target"
    :rel="target === '_blank' ? 'noopener' : false"
  >
    <template v-if="!responsiveImg">
      <aspect-ratio-box v-if="aspectRatio" :ratio="aspectRatio">
        <img :src="image.src" :alt="image.alt">
      </aspect-ratio-box>
      <img v-else :src="image.src" :alt="image.alt" class="image resp-image">
    </template>

    <template v-else>
      <aspect-ratio-box v-if="aspectRatio" :ratio="aspectRatio">
        <responsive-img :sources="image"></responsive-img>
      </aspect-ratio-box>
      <responsive-img
        v-else
        :sources="image"
        class="image resp-image"
      ></responsive-img>
    </template>

    <component
      class="text-container"
      :class="textContainerClass"
      :is="contentTag"
    >
      <slot name="name"></slot>
      <slot name="role"></slot>
      <slot name="city"></slot>
      <slot name="excerpt"></slot>
    </component>

    <icon-link
      v-if="link"
      class="cta text-14"
      :href="link"
      :target="target"
      :rel="target === '_blank' ? 'noopener' : false"
      :icon="linkIcon"
      :aria-label="linkAriaLabel"
    >{{linkText}}
    </icon-link>
  </component>
</template>

<script>
  import AspectRatioBox from '@components/layout/aspect-ratio-box';
  import ResponsiveImg from '@components/atoms/responsive-img';
  import IconLink from '@components/atoms/icon-link';

  export default {
    name: 'PeopleCard',
    components: {
      IconLink,
      ResponsiveImg,
      AspectRatioBox
    },
    props: {
      image: {
        type: Object,
        required: true
      },
      responsiveImg: {
        type: Boolean,
        default: false
      },
      aspectRatio: {
        type: Number
      },
      linkText: {
        type: String,
        default: 'Show more'
      },
      linkAriaLabel: {
        type: String,
        default: null
      },
      link: {
        type: String
      },
      target: {
        type: String
      },
      linkIcon: {
        type: String,
        default: 'arrow-right'
      },
      textContainerClass: {
        type: String
      }
    },
    computed: {
      componentTag() {
        return this.link ? 'a' : 'figure';
      },
      contentTag() {
        return this.link ? 'div' : 'figcaption';
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "~$scss/variables";

  .PeopleCard {
    display: block;
    background: #fff;

    &.link {
      .image {
        transition: opacity .3s ease;
      }

      &:hover {
        .image {
          opacity: .8;
        }
      }
    }

    .text-container {
      margin: 0;
      padding: 35px 0 0;
      text-align: left;

      .excerpt {
        margin: 16px 0;
        word-break: break-word !important;

        &:before {
          content: '“';
        }

        &:after {
          content: '”';
        }
      }
    }

    .cta {
      margin: 0;
      padding: 0;
    }

    // Theme border box
    &.border-box {
      border: 1px solid $color-grey-medium-2;

      .text-container {
        padding: 20px 25px 0;
      }

      .cta {
        padding: 0 25px 20px;
      }
    }
  }
</style>
